/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { useRequestData, useFlags } from 'wsm-common-data';
import PropTypes from 'prop-types';

import imageResizer from '../../helpers/imageResizer';

const ImageDisplay = ({
	image,
	index,
	onClick,
	keyName,
	imgTitle,
	carouselIndex,
	isRightHandImage
}) => {
	const flags = useFlags();
	const flagRemoveResizer =
		flags['ws-vehicle-gallery-toggle-idc-image-resize'] || false;
	const { deviceType } = useRequestData();
	const { src = '' } = image || {};
	const imageSrc = imageResizer(src, deviceType, flagRemoveResizer);
	const isVisible = isRightHandImage || index === carouselIndex;

	return (
		<button
			className="btn w-100 p-0 border-0"
			type="button"
			key={`${keyName}-${imageSrc}`}
			onClick={onClick}
			tabIndex={isVisible ? 0 : -1}
		>
			<img
				loading={index === 0 ? 'eager' : 'lazy'}
				// eslint-disable-next-line react/no-unknown-property
				fetchpriority={index === 0 ? 'high' : 'low'}
				className="w-100"
				src={imageSrc}
				alt={imgTitle}
				style={{
					aspectRatio: 'auto 4 / 3'
				}}
				title={imgTitle}
			/>
		</button>
	);
};

ImageDisplay.propTypes = {
	image: PropTypes.shape({
		src: PropTypes.string,
		thumb: PropTypes.string
	}).isRequired,
	index: PropTypes.number.isRequired,
	onClick: PropTypes.func,
	keyName: PropTypes.string,
	imgTitle: PropTypes.string,
	carouselIndex: PropTypes.number,
	isRightHandImage: PropTypes.bool
};

export default ImageDisplay;
